module.exports = __webpack_public_path__ + "static/media/Samoa.fbd6f7d6.png";